(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boostly-header"]) return;
  try {
    
document.addEventListener('click',function(event){document.querySelectorAll('.bh-menu[open]').forEach(function(menu){if(!menu.contains(event.target)||event.target.closest('.bh-menu__panel a'))menu.open=false;});});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.bh-menu[open]').forEach(function(menu){menu.open=false;menu.querySelector('summary').focus();});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boostly-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (!root || root.dataset.interactiveReady === 'true') return;
      root.dataset.interactiveReady = 'true';
      const demo = root.querySelector('[data-tap-demo]');
      if (!demo) return;
      const buttons = Array.from(demo.querySelectorAll('[data-demo-step]'));
      const kicker = demo.querySelector('[data-demo-kicker]');
      const title = demo.querySelector('[data-demo-title]');
      const copy = demo.querySelector('[data-demo-copy]');
      const progress = Array.from(demo.querySelectorAll('.bh-demo__progress i'));
      const steps = [
        { kicker: 'Step 1 of 3', title: 'Tap the Boostly product', copy: 'Hold the phone near the marked NFC point. There is no app to download.' },
        { kicker: 'Step 2 of 3', title: 'Your review link opens', copy: 'The phone opens the direct Google review link programmed for your business.' },
        { kicker: 'Step 3 of 3', title: 'Share genuine feedback', copy: 'The customer can choose a rating and leave their honest review while the experience is fresh.' }
      ];
      const showStep = (index) => {
        const step = steps[index];
        if (!step) return;
        demo.dataset.activeStep = String(index);
        buttons.forEach((button, buttonIndex) => button.setAttribute('aria-pressed', String(buttonIndex === index)));
        progress.forEach((item, progressIndex) => item.classList.toggle('is-active', progressIndex <= index));
        kicker.textContent = step.kicker;
        title.textContent = step.title;
        copy.textContent = step.copy;
      };
      buttons.forEach((button) => button.addEventListener('click', () => showStep(Number(button.dataset.demoStep))));
    };
    document.querySelectorAll('.bh-home').forEach(setup);
    document.addEventListener('shopify:section:load', (event) => setup(event.target.querySelector('.bh-home')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
